import { VariantSelector } from "./variant-selector";
import { CLASS_DISABLED } from "../../tools/constants/classes";

export const SEL_SWATCH_CONTAINER = '[data-swatches]';
const SEL_SWATCH = '[data-swatch]';
const SEL_SWATCH_OBJECT = '[data-swatch-object]';
const SEL_SWATCH_DROPDOWN = '[data-swatch-dropdown]';
const SEL_SWATCH_VALUE = '[data-swatch-value]';
const SEL_SWATCH_TITLE = '[data-swatch-title]';
const SEL_THUMBNAIL = '.o-product-thumbnail';
const SEL_THUMBNAIL_IMAGE = '.o-product-thumbnail__image-container';

const SEL_IMAGE = '[data-image]';
const ATTR_POSITION = 'data-swatch-position';
const ATTR_VALUE = 'data-value';
const ATTR_BTN_TITLE = 'data-title';

const CLASS_SELECTED = 'is-selected';

export class Swatches extends VariantSelector {
  public readonly swatches:HTMLDivElement[];

  constructor(container:HTMLElement, updateHistory?:boolean) {
    super(container, updateHistory);
    this.swatches = Array.from(container.querySelectorAll<HTMLDivElement>(SEL_SWATCH).values());

    // Listen for button presses
    this.container.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT).forEach(btn => {
      btn.addEventListener('click', this.onSwatchClick);
    });

    // Listen for dropdown changes
    this.container.querySelectorAll<HTMLSelectElement>(SEL_SWATCH_DROPDOWN).forEach(dd => {
      dd.addEventListener('change', this.onDropdownChange)
    });

    this.onVariantSelected();

    // on load, remove text after '/' on swatch title
    const title = this.container.querySelector<HTMLElement>(SEL_SWATCH_TITLE);
    if (title) {
      title.innerText = title.innerText.split('/')[0];
    }
  }

  private onSwatchClick = (e:MouseEvent) => {
    const title = this.container.querySelectorAll<HTMLElement>(SEL_SWATCH_TITLE);
    const btn = e.currentTarget as HTMLElement;
    const swatch = btn.closest(SEL_SWATCH);

    let objImage = btn.querySelector(SEL_IMAGE);
    let mainImageWrapper = this.container.closest(SEL_THUMBNAIL)?.querySelector(SEL_THUMBNAIL_IMAGE);
   
    if(!swatch) return;

    const attrPosition = parseInt(swatch.getAttribute(ATTR_POSITION)||'');
    const attrValue = btn.getAttribute(ATTR_VALUE);
    const btnTitle = btn.getAttribute(ATTR_BTN_TITLE);
    if(btnTitle){
      title?.forEach(titleElement => {
        titleElement.innerText = btnTitle;
      });
    }
    if(isNaN(attrPosition) || !attrValue) return;


    if(objImage && mainImageWrapper) {
      mainImageWrapper.innerHTML = objImage.innerHTML
    } 

    this.setVariantOption(attrPosition - 1, attrValue);
  }

  private onDropdownChange = (e:Event) => {
    const title =this.container.querySelector<HTMLElement>(SEL_SWATCH_TITLE);
    const sel = e.currentTarget as HTMLSelectElement;
    const swatch = sel.closest(SEL_SWATCH);
    if(!swatch) return;
    const attrPosition = parseInt(swatch.getAttribute(ATTR_POSITION)||'');
    const btnTitle = sel.options[sel.selectedIndex].text;
    if(btnTitle){
      title!.innerText = btnTitle
    }
    if(isNaN(attrPosition)) return;
    this.setVariantOption(attrPosition - 1, sel.value);
  }

  public onVariantSelected() {
    const variant = this.getVariant();
    if(!variant) return;
    
    this.swatches.forEach(swatch => {
      const attrPosition = parseInt(swatch.getAttribute(ATTR_POSITION)||'');
      if(isNaN(attrPosition)) return;
      const value = variant.options[attrPosition - 1];

      // Update btn classes
      const objs = swatch.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT);
      objs.forEach(obj => {
        const objVal = obj.getAttribute(ATTR_VALUE);
        if(objVal === value) {
          obj.classList.add(CLASS_SELECTED);
          let parent = obj.parentElement;
          if(parent){
            parent.classList.add(CLASS_SELECTED);
          }
        } else {
          obj.classList.remove(CLASS_SELECTED);
          let parent = obj.parentElement;
          if(parent){
            parent.classList.remove(CLASS_SELECTED);
          }
        }
      });

      // Update dropdowns
      const sels = swatch.querySelectorAll<HTMLSelectElement>(SEL_SWATCH_DROPDOWN);
      sels.forEach(sel => sel.value = value);

      // Update title(s)
      swatch.querySelectorAll<HTMLElement>(SEL_SWATCH_VALUE).forEach(sv => {
        sv.textContent = value;
      });

    });

    this.setDisableClass();

    if (this.container.classList.contains('o-product-thumbnail__footer')) {
      const updatePricingEvt = new CustomEvent('updatePricing', {
        bubbles: true,
        cancelable: false,
        detail: {
          variant
        }
      });
      this.container.dispatchEvent(updatePricingEvt);
    }
  }

  private setDisableClass() {
    const currentVariant = this.getVariant();
    let availableVariants:any[] = [];

    if (this.data.options.length > 1) {
      availableVariants = this.data.variants.filter(
        v => v.options.includes(currentVariant.options[0])
          || v.options.includes(currentVariant.options[1])
      );
    } else {
      availableVariants = this.data.variants.filter( v => v.available);
    }
      
    this.clearDisableClass();

    this.swatches.forEach(swatch => {

      // Update btn classes
      const objs = swatch.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT);
      objs.forEach(obj => {
        if (!obj) return;
        const swatchValue = obj.getAttribute(ATTR_VALUE);

        const hasMatchingValue = availableVariants.some(
          v => v.options.includes(swatchValue)
        );

        if (!hasMatchingValue) {
          obj.classList.add(CLASS_DISABLED);
        }
      });
    });
  }

  private clearDisableClass() {
    this.swatches.forEach(swatch => {
      const objs = swatch.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT);
      objs.forEach(obj => {
        obj.classList.remove(CLASS_DISABLED);
      });
    });
  }

  public dispose() {
    super.dispose();

    this.container.querySelectorAll<HTMLElement>(SEL_SWATCH_OBJECT).forEach(btn => {
      btn.removeEventListener('click', this.onSwatchClick);
    });

    this.container.querySelectorAll<HTMLSelectElement>(SEL_SWATCH_DROPDOWN).forEach(dd => {
      dd.removeEventListener('change', this.onDropdownChange);
    });
  }
}
